import { createComponent } from '@carvana/merch-components';
import styles from './VehicleDetailsContainer.module.css';

export const Wrapper = createComponent('main', {
  className: styles.wrapper
});
